import { Link } from 'react-router-dom';
import { Text, Anchor } from '@mantine/core';
import type { MantineSize, MantineSpacing } from '@mantine/core';

interface Props {
  content: string;
  lineClamp?: number;
  size?: MantineSize;
  mb?: MantineSpacing;
}

export function ReviewContent({ content, lineClamp, size = 'sm', mb }: Props) {
  const parts = content.split(/(#[a-zA-Z0-9_]+)/g);

  return (
    <Text size={size} lineClamp={lineClamp} mb={mb} style={{ whiteSpace: 'pre-wrap' }}>
      {parts.map((part, i) =>
        part.startsWith('#') ? (
          <Anchor
            key={i}
            component={Link}
            to={`/tags/${part.slice(1).toLowerCase()}`}
            size={size}
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </Anchor>
        ) : (
          part
        )
      )}
    </Text>
  );
}
